'use client';

import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import { ErrorServiceUnavailable } from '@/components/common/Error';
const VaultV2YourPositionChartError = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ErrorServiceUnavailable minHeight="395px" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default memo(VaultV2YourPositionChartError);